<template>
  <span>
    <select @change="onChangeCheck" v-model="selectObject">
      <option v-show="level !== 0" :value="{}">전체 선택</option>
      <option v-show="select.checked === true" v-for="(select, i) in item" :value="select">{{select.itemName}}</option>
    </select>
    <MultiSelect ref="childSelect" v-if="selectObject.child && selectObject.child.length > 0"
                 @select-update="updateSelect" :item="selectObject.child" :level="1">
    </MultiSelect>
  </span>
</template>

<script>
export default {
  name: "MultiSelect",
  mounted() {
  }
  ,props: {
    item: {
    },
    level: {
    },
    code: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      selectedValue: '',
      selectObject: {}
    }
  },
  methods: {
    initSelect(item) {
      if (item === undefined) {
        this.selectObject = {}
      } else {
        this.selectObject = item
      }
      if (this.$refs.childSelect) {
        this.$refs.childSelect.initSelect();
      }

    },
    onChangeCheck (evt) {
      if (this.selectObject.itemKeyPath !== undefined) {
        this.callParent(false, this.selectObject.itemKeyPath);
      } else {
        this.callParent(true, '');
      }
      if (this.$refs.childSelect) {
        this.$refs.childSelect.initSelect();
      }
    },
    // 하위에서 데이터 받음
    updateSelect (isAll, param) {
      if (isAll) {
        // 하위에서 전체 일때, 나도 전체 일경우
        if (this.selectObject.itemKeyPath === undefined) {
          this.callParent(isAll, param);
        } else {
          this.callParent(isAll, this.selectObject.itemKeyPath);
        }
      } else {
        this.callParent(isAll, param);
      }
    },
    // 상위 함수 호출
    callParent (isAll, param) {
      this.$emit('select-update', isAll, param);
    }
  }

}
</script>

<style scoped>

</style>
